import { Routes } from '@angular/router';
import { Dashboard } from './features/dashboard/dashboard';
import { TransactionsComponent } from './features/transactions/transactions';
import { ExpenseTotalWidgetComponent } from './features/dashboard/widgets/expense-total-widget/expense-total-widget';
import { TransferFund } from './features/transfer-fund/transfer-fund';
import { RequestConsent } from './features/request-consent/request-consent';
import { ConsentCallback } from './features/consent-callback/consent-callback';
import { SettingsComponent } from './features/settings/settings';
import { Bills } from './features/bills/bills';

export const routes: Routes = [
  { path: 'request-consent', component: RequestConsent },
  { path: 'consent-callback', component: ConsentCallback },
  { path: 'dashboard', component: Dashboard },
  { path: 'transactions', component: TransactionsComponent },
  { path: 'accounts', component: Dashboard },
  { path: 'bills', component: Bills },
  { path: 'transfer', component: TransferFund },
  { path: 'investments', component: Dashboard },
  { path: 'expense-total', component: ExpenseTotalWidgetComponent },
  { path: 'settings', component: SettingsComponent },
  { path: '', redirectTo: 'request-consent', pathMatch: 'full' }
];
